import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import LargeTitle, { ColorType } from '../../atoms/LargeTitle/LargeTitle'

import './RankingPrepare.css'

const RankingPrepare = ({ children, isLoading }) => {
  return (
    <div styleName="container">
      <div styleName="l-text">
        <LargeTitle color={ColorType.WHITE}>{children}</LargeTitle>
      </div>
      <p styleName="subtext">{isLoading ? '集計中...' : '集計完了'}</p>
    </div>
  )
}

RankingPrepare.propTypes = {
  children: PropTypes.string.isRequired,
  isLoading: PropTypes.bool
}

RankingPrepare.defaultProps = {
  isLoading: false
}

export default compose(pure)(RankingPrepare)
